<script setup lang="ts">
import { RowSlot } from '@shared/ui/other'
import { NativeSelect } from '@shared/ui/fields'

import { useTutorKanbanSelectCategory } from '../../model/tutor-kanban-select-category.hook'
import ModalConfirmExitChange from '../modals/ModalConfirmExitChange.vue'

defineOptions({
  name: 'TutorKanbanSelectCategory',
})

const {
  isVisible,
  isRequired,
  refOptions,
  refValue,
  refMode,
  refResetKey,
  isConfirmOpen,
  setChange,
  setConfirmChange,
  setCancelChange,
} = useTutorKanbanSelectCategory()
</script>

<template>
  <RowSlot
    v-if="isVisible"
    label="Stage category"
    :required="isRequired"
  >
    <NativeSelect
      :key="refResetKey"
      name="stage-category"
      placeholder="Select stage category"
      placeholder-enabled
      :options="refOptions"
      :value="refValue"
      :mode="refMode"
      @change="setChange"
    />
    <ModalConfirmExitChange
      :show="isConfirmOpen"
      title="You sure you want to change tutor's exit category?"
      @click:confirm="setConfirmChange"
      @click:cancel="setCancelChange"
    />
  </RowSlot>
</template>
